import React from 'react';
import {Modal, Button, Tabs, Tab} from 'react-bootstrap'
import {connect} from 'react-redux'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {addingStockUnit, addingStockUnitSuccess, addingStockUnitFailure, resetAddingStockUnit} from '../../redux/actions/stockactions'
import {getToken} from '../../storage'
import 'react-select/dist/react-select.css';
const initialState = {
  show:false
}


class ControlledTabs extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleTabSelect = this.handleTabSelect.bind(this)
    this.state = {key:1}
  }
  handleTabSelect(key) {
    this.setState({key})
    this.props.handleUnitType(key)
  }
  render() {
    return (<Tabs animation={false} id="createUnitTabs" activatekey={this.state.key} onSelect={this.handleTabSelect}>
      <Tab eventKey={1} title="Normal">
        <div style={{paddingTop:20}}>
          <form className="form-horizontal" onSubmit={this.props.handleSubmit} id="createUnitNormalForm" name="createUnitNormalForm">
            <div className="form-group">
              <div className="col-sm-3">
                Unit name
              </div>
              <div className="col-sm-4">

                <input type="text" name="normal_unit_name" className="form-control input-sm" onChange={this.props.handleInputChange}  />
              </div>

            </div>
          </form>
        </div>
      </Tab>
      <Tab eventKey={2} title="Advanced">
        <div style={{paddingTop:20}}>
          <form  className="form-horizontal" onSubmit={this.props.handleSubmit} id="createUnitForm" name="createUnitForm">

            <div className="form-group">
              <div className="col-sm-6">
                Primary Unit Quantity
              <input type="number" name="primary_unit_quantity" className="form-control input-sm" onChange={this.props.handleInputChange}/>
              </div>
              <div className="col-sm-6">
              Primary Unit Name
              <input type="text" name="primary_unit_name" className="form-control input-sm" onChange={this.props.handleInputChange}/>
              </div>
            </div>

            <div className="form-group">
              <div className="col-sm-6">
                Secondary Unit Quantity
              <input type="number" name="secondary_unit_quantity" className="form-control input-sm" onChange={this.props.handleInputChange}/>
              </div>
              <div className="col-sm-6">
              Secondary Unit Name
              <input type="text" name="secondary_unit_name" className="form-control input-sm" onChange={this.props.handleInputChange}/>
              </div>
            </div>


            <p><i>eg: <strong>1</strong> box of <strong>20</strong> bottles</i></p>
            <ul className="list-unstyled">
              <li>1 = primary unit quantity</li>
              <li>Box = primary unit name</li>
              <li>20 = secondary unit quantity</li>
              <li>Bottle = secondary unit name</li>

            </ul>
          </form>
        </div>
      </Tab>

    </Tabs>)
  }
}

class AddUnitButton extends React.Component {



  constructor(props) {
    super(props)
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleUnitType = this.handleUnitType.bind(this)
    this.state = initialState

  }

  handleUnitType(key) {
    if(key===2) {
        this.setState({unit_type:'A'})
    }
  }

  handleInputChange(event) {
    if(event.target.name === "createStockForm") {
      return false
    }
    event.preventDefault()
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    // if(target.type !== "checkbox") {
    //   value = value.trim()
    // }

    const name = target.name;
    this.setState({
     [name]: value
   });
  }

  handleSubmit(event) {

    event.preventDefault()
    this.props.dispatch(addingStockUnit())
    axios({
      url: '/create_new_stock_unit/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state
    }).then((response)=> {
      if(response.status === 200) {
        console.log("dispatching stock item");
        this.props.dispatch(addingStockUnitSuccess(response.data.stock_unit))
        this.setState(initialState)
        console.log(this.state);
      }
      this.props.dispatch(resetAddingStockUnit())
    }).catch((err)=> {
      console.log(err);
      this.props.dispatch(addingStockUnitFailure(err.response.data))

    })

  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }


  render() {

    const show = this.state.show

    let button = <button type="button" className="btn btn-sm btn-info btn-block" onClick={this.handleShow}>Add Unit</button>
    let createButton  = <button name="createStockUnit" form="createUnitForm" type="submit" className="btn btn-info">Create</button>
    if(this.props.stock.adding_stock_unit) {
      createButton = <button name="createStockUnit" form="createUnitForm" type="submit" className="btn btn-info" disabled>Creating..</button>
    }
      const modal = (
          <Modal show={show} onHide={this.handleClose}>
            <Modal.Header closeButton>
             <Modal.Title>Create Unit for Stock Item</Modal.Title>
           </Modal.Header>
            <Modal.Body>

              <ControlledTabs handleSubmit={this.handleSubmit} handleInputChange={this.handleInputChange} handleUnitType={this.handleUnitType} />

            </Modal.Body>
            <Modal.Footer>
            {createButton}
            <Button onClick={this.handleClose}>Close</Button>

           </Modal.Footer>
          </Modal>
      )
    return (<div>
            {button}{modal}
      </div>)

  }
}

const mapStateToProps  = (state)=> {
  return {
    stock: state.stockReducer
  }
}

export default connect(mapStateToProps)(AddUnitButton)



// WEBPACK FOOTER //
// ./src/components/stockitem/addstockunit.js